<template>
  <div class="termPolicy">
    <section class="main_section">
      <div class="page-contentbox">
        <a @click="goBack" class="back-link">
          <i class="material-icons">arrow_back_ios</i> Back
        </a>
        <h2>Terms & Conditions</h2>

        <p>By using the website you agree to the following terms and conditions in the agreement. Please note that in event of change in this agreement we will publish it online at the website. We encourage you to review the site periodically for such changes. This is a legal and binding document between you and Rovi91 Innovations Pvt Ltd (https://www.mall91.com) is fully owned by Rovi91 Innovations Pvt Ltd.</p>

        <h4>IMPORTANT</h4>

        <p>The information provided on this web site includes, but is not limited to, the services provided by Rovi91 Innovations Pvt Ltd., and does not render any advice, certifications, guarantees or warranties on the Content (as defined below) relating to the services, which Rovi91 Innovations Pvt Ltd makes available on this Site. Rovi91 Innovations Pvt Ltd. will be referred to as Rovi91 Innovations Pvt Ltd in the rest of the document.</p>

        <h4>TERMS OF USE</h4>

        <p>The use of this Site and the Content contained herein are governed by these Terms of Use ("Agreement"). When you use this Site you acknowledge that you have read this Agreement and that you accept and will be bound by the terms hereof as such terms may be modified from time to time.</p>

        <h4>1. PURPOSE</h4>

        <p>1.1 As stated above, the contents provided on or through this Site are solely for information purposes and do not substitute for specific advice whether investment, legal, or otherwise and are not intended to provide you with any nature of certification, guarantee or warranty. By accessing, browsing and using this Site, you agree and acknowledge that you understand this limited and restricted use and agree that you would not rely on the information and materials contained in this Site for any purposes except as Rovi91 Innovations Pvt Ltd intended or specified under this Agreement. You further agree that in all actual matters, you are ultimately responsible for determining your specific requirements and consequences thereof. Rovi91 Innovations Pvt Ltd claims all liability for damages caused by use of Content on the Site. You agree that you are providing Rovi91 Innovations Pvt Ltd with personal details regarding your mobile phone, address. You also agree that Rovi91 Innovations Pvt Ltd may use the information for automated analysis. You further agree that Rovi91 Innovations Pvt Ltd, to increase the value and benefit of this service to you, may provide your name and contact information to a third party service provider.</p>

        <p>1.2 Rovi91 Innovations Pvt Ltd will provide services to enable registered users to create their own shopping group OR join existing shopping groups for items posted on site, to avail discounts on their purchases for those items. Rovi91 Innovations Pvt Ltd would enable registered users to buy items on discount posted by Rovi91 Innovations Pvt Ltd as well. Users can also do their purchases offline by themselves with their group members and Rovi91 Innovations Pvt Ltd just provides a convenient online channel for users to do such activities. Rovi91 Innovations Pvt Ltd takes no guarantee about the conditions/quality of items being purchased by users by themselves. Rovi91 Innovations Pvt Ltd takes no guarantee on delivery of items unless otherwise stated on site. Rovi91 Innovations Pvt Ltd makes no claims that the data is accurate or applicability of the information to any specific situation.</p>

        <p>1.3 At the time of registration on the site, the user agrees that he/she would post only legal/fully-owned/original items on site (any other category that Rovi91 Innovations Pvt Ltd supports now or in future). The user agrees that he is not posting any pirated items or doing any copyright violations. In case of any incident where a user violates this condition, Rovi91 Innovations Pvt Ltd has full rights to terminate the registration of user and take legal action as applicable and appropriate.</p>

        <p>1.4 Rovi91 Innovations Pvt Ltd takes no guarantee and cannot monitor that all items posted on site by the registered users do not violate any copyrights or are not pirated. The registered users agree at the time of sign up with the service that they would not violate any copyright or would not post any pirated items (refer 1.3). In case of any such incident, Rovi91 Innovations Pvt Ltd bears no liability and any legal action is applicable on the user who posted the item. Rovi91 Innovations Pvt Ltd agrees to provide full cooperation to the affected party/parties however, which would include removing pirated content, providing user's details held in database and terminating user's registration on the site.</p>

        <p>1.5 Rovi91 Innovations Pvt Ltd may also provide the user the ability to send SMS to the user's top callers or send an email to the users friends letting them know about the service.</p>

        <p>1.6 The Site may provide certain Features ("Site" and "Features" as defined under Section 2) that enable sending/receiving invites/solicitation messages/reminders to your contacts whose details, as required under the specific Features, are submitted and specifically permitted by you to be so used. Once such a Feature is selected and consented by you, you specifically agree that the Feature shall enable sending one instant message and a maximum of 3 reminders.</p>
        <h4>2. DEFINITIONS</h4>

        <p>
          2.1 "Contents" or "Content" shall mean any and all information, data, text, software, music, sound, photographs, graphics, video, messages, materials, news, notices, articles, contracts, forms,
          documents or other materials and information which may be viewed or downloaded on or through this Site. Contents shall also include any e-mail, messages, e-cards or any other information furnished by
          a user to be displayed on the Site by Rovi91 Innovations Pvt Ltd.
        </p>

        <p>2.2 "Feature" or "Features": A "Feature" may include any interactive, value addition service or other additional feature, introduced on the Site.</p>

        <p>2.3 "Site" shall mean the internet site identified generally by the URL and all pages linked to that URL which pages are posted and operated by Rovi91 Innovations Pvt Ltd or its agents.</p>
        <h4>3. REPRESENTATIONS AND WARRANTIES</h4>

        <p>
          3.1 Rovi91 Innovations Pvt Ltd or any of its affiliates or associates or employees shall not be in any way responsible for any loss or damage that may arise to any person from any inadvertent error in the
          information contained in this Site. The information from or through this Site is provided "as is" and all warranties express or implied of any kind,
          regarding any matter pertaining to the Site or the Content including, without limitation, the implied warranties of merchantability, fitness for a particular purpose,
          and non-infringement are disclaimed.
        </p>

        <p>
          3.2 Rovi91 Innovations Pvt Ltd and its affiliates and associates shall not be liable, at any time, for any failure of performance, error, omission, interruption, deletion, defect, delay in operation or transmission,
          computer virus, communications line failure, theft or destruction or unauthorized access to, alteration of, or use of information contained on the Site. No representations,
          warranties or guarantees whatsoever are made as to the accuracy, adequacy, reliability, completeness, suitability or applicability of the information to a particular situation.
        </p>
        <h4>3.4. YOUR CONDUCT</h4>

        <p>
          4.1 You may post your reviews or comments, and submit suggestions, ideas, questions, or other information, so long as the Contents are not illegal, obscene, threatening, defamatory,
          invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and do not consist of or contain software viruses,
          political campaigning, commercial solicitation, chain letters, mass mailings, or any form of "spam". You shall not use a false e-mail address, impersonate any person or entity,
          or otherwise mislead as to the origin of the Contents. However, you acknowledge that Rovi91 Innovations Pvt Ltd does not pre-screen the Content, but that Rovi91 Innovations Pvt Ltd and its designs shall have the right (but not the obligation) in
          their sole discretion to accept, refuse, move, or remove any Contents that are available via the Site.
        </p>

        <p>
          4.2 You understand that all Contents, whether publicly posted or privately transmitted, are the sole responsibility of the person from which such Content originated.
          This means that you, and not Rovi91 Innovations Pvt Ltd, are entirely responsible for all Content that you have provided Rovi91 Innovations Pvt Ltd with in order to upload, post, transmit or otherwise make available via the Site.
          But not the obligation) in their sole discretion to accept, refuse, move, or remove any Contents that are available via the Site.
        </p>

        <p>4.3 You expressly agree not to use the Site to:</p>

        <p>(i) harm any user in any manner either directly or indirectly.</p>

        <p>(ii) forge headers or otherwise manipulate identifiers in order to disguise the origin of any Contents transmitted through the Site.</p>

        <p>
          (iii) disrupt the normal flow of dialogue, cause a screen to "scroll" faster than other users of the Site are able to type, or otherwise act in a manner that negatively affects other users'
          ability to engage in real time exchanges or "stalk" or in any other manner harass another user.
        </p>

        <p>(iv) interfere with or disrupt the Site or servers or networks connected to the Site, or disobey any requirements, procedures, policies or regulations of networks connected to the Site.</p>

        <p>(v) upload or transmit any material that is deemed derogatory with respect to the name, services or Contents relating to or provided by Rovi91 Innovations Pvt Ltd.</p>

        <p>(vi) intentionally or unintentionally violate any applicable local, state, national or international laws.</p>

        <p>4.4 You expressly represent and warrant that:</p>

        <p>(i) you are capable to use this Site in accordance with all terms and conditions herein in relation to the access and use of this Site and the services provided therein. and</p>

        <p>
          (ii) all information supplied by you in any correspondences or any other documentation to Rovi91 Innovations Pvt Ltd is true, current complete and accurate.
          You expressly agree that this clause shall survive any termination of this Agreement.
        </p>
        <h4>5. LINKS TO OTHER WEBSITES</h4>

        <p>
          This Site may contain hyperlinks to websites operated by parties other than Rovi91 Innovations Pvt Ltd. The inclusion of hyperlinks to such websites does not imply Rovi91 Innovations Pvt Ltd's certification or endorsement of
          such websites nor any association with their operators. Rovi91 Innovations Pvt Ltd or its affiliates or associates or its employees do not provide any judgment or warranty in respect of the authenticity or
          correctness of the content of such other services or sites to which links are provided. A link to another service or site is not an endorsement of any products or services on such site or the Site.
          You shall be solely responsible for any or all the consequences that arise out of your use of such hyperlinks to websites.
        </p>
        <h4>6. INFRINGEMENT</h4>

        <p>
          Do not post content that infringes the rights of third parties, This includes, but is not limited to, content that infringes on intellectual property rights such as copyright and trademark
          (e.g. offering counterfeit items for sale). A large number of very varied products are offered on Rovi91 Innovations Pvt Ltd by private individuals in India. Entitled parties,
          in particular the owners of copyright, trademark rights or other rights owned by third parties can report any offers which many infringe on their rights,
          and submit a request for this offer to be removed. If a legal representative of the entitled party reports this to us in the correct manner,
          products infringing on the intellectual property rights will be removed by Rovi91 Innovations Pvt Ltd.
        </p>

        <p>
          In order to report a case of Infringement, you only need to send an email at . You can report postings which may infringe on your property rights.
          The information is for the purpose of ensuring that the parties reporting these objects are either the entitled party or their officially authorized representative.
          This information must also enable Rovi91 Innovations Pvt Ltd to identify the advertisement to be removed.
        </p>

        <p>
          Note: This facility can only be used by the lawful owners of the intellectual property rights. "Notice of Infringement" is intended to ensure that products offered do not infringe the copyright,
          trademark right or other intellectual property rights of third parties.
        </p>
        <h4>7. LIABILITY</h4>

        <p>
          Nothing in these terms shall limit our liability for fraudulent misrepresentation, for death or personal injury resulting from our negligence or the negligence of our agents or employees.
          You agree not to hold us responsible for things other users post or do.
        </p>

        <p>
          We do not review users' postings and are not involved in the actual transactions between users. As most of the content on Rovi91 Innovations Pvt Ltd comes from other users, we do not guarantee the accuracy of
          postings or user communications or the quality, safety, or legality of what's offered.
        </p>

        <p>
          In no event do we accept liability of any description for the posting of any unlawful, threatening, abusive, defamatory, obscene or indecent information,
          or material of any kind which violates or infringes upon the rights of any other person, including without limitation any transmissions constituting or encouraging conduct that would
          constitute a criminal offence, give rise to civil liability or otherwise violate any applicable law.
        </p>

        <p>
          We cannot guarantee continuous, error-free or secure access to our services or that defects in the service will be corrected. While we will use reasonable efforts to maintain an
          uninterrupted service, we cannot guarantee this and we do not give any promises or warranties (whether express or implied) about the availability of our services.
        </p>

        <p>
          Accordingly, to the extent legally permitted we expressly disclaim all warranties, representations and conditions, express or implied, including those of quality, merchantability,
          merchantable quality, durability, fitness for a particular purpose and those arising by statute. We are not liable for any loss, whether of money (including profit), goodwill, or reputation,
          or any special, indirect, or consequential damages arising out of your use of Rovi91 Innovations Pvt Ltd, even if you advise us or we could reasonably foresee the possibility of any such damage occurring.
          Some jurisdictions do not allow the disclaimer of warranties or exclusion of damages, so such disclaimers and exclusions may not apply to you.
        </p>
        <h4>8. INTELLECTUAL PROPERTY</h4>

        <p>
          All text, graphics, audio, design and other works on the Site are the copyrighted works of Rovi91 Innovations Pvt Ltd unless otherwise indicated. Content on the Site is for personal use only.
          Any alteration of the material or use of the material contained in the Site for any commercial purpose is a violation of the copyright of Rovi91 Innovations Pvt Ltd and/or its affiliates or associates or of
          its third-party information providers. The Content available on the Site shall not be copied, reproduced, republished, uploaded, posted, transmitted or distributed in any way without
          obtaining the prior permission from Rovi91 Innovations Pvt Ltd. All responsibility and liability for any damages caused by downloading of any data is disclaimed.
        </p>
        <h4>9. LICENSE AND SITE ACCESS</h4>

        <p>
          9.1 Rovi91 Innovations Pvt Ltd grants you a "limited non-exclusive
          license" to access and make personal (non commercial) use of
          this Site for informational purposes and not to modify either
          the whole or any portion of the Site.
        </p>

        <p>9.2 The license shall not include:</p>

        <p>
          (i) any resale or commercial use of this Site
          or its Contents; or
        </p>

        <p>
          (ii) any derivative use of this Site or its
          Contents.
        </p>

        <p>
          9.3 You, your partners, your employees, your
          agents or any other person associated with you personally or
          professionally, may not, with or without compensation, prepare
          any derivative works from, or sell, lease, license, e-mail,
          reproduce, duplicate, copy, resell, republish, transmit or
          distribute or otherwise exploit for any commercial purpose via
          any media, now known or unknown, any Contents from this Site
          to any other entity or individual. No Contents or information
          on the Site may be reproduced in any form or incorporated into
          any internet web-site or any other information retrieval
          system, either electronic or mechanical. It is a condition of
          your use of this Site that you do not restrict or inhibit any
          other user from using this Site.
        </p>

        <p>
          9.4 You shall not frame or utilize framing
          techniques to enclose any trademark, logo, or other
          proprietary information (including images, text, page layout,
          or form) of Rovi91 Innovations Pvt Ltd and/or our affiliates without the express
          written consent of Rovi91 Innovations Pvt Ltd. You may not use any meta tags or
          any other "hidden text" utilizing Rovi91 Innovations Pvt Ltd's name or trademarks
          without the express written consent of Rovi91 Innovations Pvt Ltd. Any
          unauthorized use terminates the permission and the license
          granted by Rovi91 Innovations Pvt Ltd under this Agreement to you.
        </p>
        <h4>10. MODIFICATIONS ON THE SITE</h4>

        <p>
          10.1 Rovi91 Innovations Pvt Ltd reserves the right to modify,
          suspend/cancel, or discontinue any or all sections, or service
          at any time without notice. Rovi91 Innovations Pvt Ltd reserves the right to make
          modifications and alterations in the information contained on
          the Site without notice. You agree that Rovi91 Innovations Pvt Ltd shall not be
          liable to you or to any third party for any modification,
          suspension or discontinuance of the Site.
        </p>

        <p>
          10.2 You expressly agree that any information
          provided on the Site shall be used by you at your risk. You
          are advised to hereby make proper enquiries and use the
          information provided on the Site.
        </p>

        <p>
          10.3 From time to time Rovi91 Innovations Pvt Ltd may supplement
          its terms of use with additional terms pertaining to specific
          content (additional terms). Such additional terms are hereby
          incorporated by reference into these Terms of Use.
        </p>
        <h4>11. Buying on Rovi91 Innovations Pvt Ltd.com</h4>

        <p>
          We strongly advise you not to test the site
          with false purchases request, as it will put you at
          substantial personal legal risk. It is a crime to use a false
          name, other false personal information to buy. Willfully
          entering erroneous or fictitious purchase request may result
          in prosecution by Rovi91 Innovations Pvt Ltd. Please be aware that even if
          you do not give Rovi91 Innovations Pvt Ltd your real name, your Web browser
          transmits a unique address to us, which can be used by law
          enforcement officials to identify you. As a seller you certify that all information provided by you against your listed catalog items is true. Sellers need to make Rovi91 Innovations Pvt Ltd aware of timely status of various catalog items listed by them.
        </p>
        <h4>12. SELLING AS A REGISTERED MEMBER</h4>

        <p>
          You may list item(s) for sale/exchange on the
          Site. You must be legally able to sell/exchange the item(s)
          you list for sale/exchange on our Site. Listings may only
          include text descriptions, graphics and pictures that describe
          your item for sale. All listed items must be listed in an
          appropriate category on the Site. Soliciting business offline
          or outside of the Site, by indicating your contact details
          (e.g. contact phone number, address or e-mail ID) in the
          listing or elsewhere on the Site other than in the appropriate
          Form is expressly prohibited and would be considered as a
          breach of the User Agreement. All listed items must be kept in
          stock for successful fulfillment of sales. The listing
          description of the item must not be misleading and must
          describe actual condition of the product. If the item
          description does not match the actual condition of the item,
          you agree to refund any amounts that you may have received
          from the buyer.
        </p>
        <h4>13. LOGIN OPTIONS</h4>

        <p>
          The Rovi91 Innovations Pvt Ltd Members login (if any) is for the
          reference of only registered Rovi91 Innovations Pvt Ltd's Member. Rovi91 Innovations Pvt Ltd
          reserves the right to discontinue the member Login on account
          of violation of this Agreement or any "Code of Conduct" set by
          Rovi91 Innovations Pvt Ltd. Rovi91 Innovations Pvt Ltd reserves the right to take all measures
          necessary to prevent access to any Content or portion of the
          Site or terminate access to the site if the terms of use are
          not complied with or are contravened or there is any violation
          of copyright, trademark or other proprietary right.
        </p>
        <h4>14. DISCLAIMER</h4>

        <p>
          Rovi91 Innovations Pvt Ltd MAKES NO WARRANTIES OR REPRESENTATIONS
          AS TO THE CONTENTS OF THIS SITE AND Rovi91 Innovations Pvt Ltd ASSUMES NO
          LIABILITY OR RESPONSIBILITY FOR ANY ERRORS OR OMISSIONS IN THE
          CONTENT ON THE SITE. THE CONTENTS ARE PROVIDED "AS IS" AND
          WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED,
          INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
          NON-INFRINGEMENT. Rovi91 Innovations Pvt Ltd FURTHER MAKES NO REPRESENTATION OR
          WARRANTY THAT ANY FILES, LINKS OR POINTERS AVAILABLE THROUGH
          THIS SITE WILL BE FREE OF VIRUSES OR OTHER CODES THAT CONTAIN
          CONTAMINATING OR DESTRUCTIVE PROPERTIES. TO THE FULLEST EXTENT
          PERMISSIBLE PURSUANT TO THE APPLICABLE LAW, Rovi91 Innovations Pvt Ltd DISCLAIMS
          ALL WARRANTIES, EXPRESS OR IMPLIED.
        </p>
        <h4>Rovi91 Innovations Pvt Ltd MAKES NO WARRANTY THAT</h4>

        <p>(i) THE INFORMATION WILL MEET YOUR REQUIREMENTS,</p>

        <p>(ii) THE SITE WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE,</p>

        <p>(iii) THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SITE WILL BE ACCURATE OR RELIABLE,</p>

        <p>(iv) THE QUALITY OF ANY INFORMATION OBTAINED BY YOU THROUGH THE SITE WILL MEET YOUR EXPECTATIONS, AND</p>

        <p>(v) ANY ERRORS IN THE SOFTWARE WILL BE CORRECTED</p>

        <p>
          ANY MATERIAL, CONTENTS OR INFORMATION
          DOWNLOADED OR OTHERWISE OBTAINED FROM THE SITE IS SUBJECT TO
          THIS AGREEMENT AND DONE AT YOUR OWN DISCRETION AND RISK AND
          THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR
          COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD
          OF ANY SUCH MATERIAL.
        </p>

        <p>
          Rovi91 Innovations Pvt Ltd is not liable on the authenticity of
          such data. Without limiting the foregoing, under no
          circumstances shall Rovi91 Innovations Pvt Ltd be held liable for any delay or
          failure in performance resulting directly or indirectly from
          acts of nature, forces, or causes beyond its reasonable
          control, including, without limitation, Internet failures,
          computer equipment failures, telecommunication equipment
          failures, other equipment failures, electrical power failures,
          strikes, labor disputes, riots, insurrections, civil
          disturbances, shortages of labor or materials, fires, floods,
          storms, explosions, acts of God, war, governmental actions,
          orders of domestic or foreign courts or tribunals,
          non-performance of third parties, or loss of or fluctuations
          in heat, light, or air conditioning.
        </p>

        <h4>15. LIMITATION OF LIABILITY</h4>

        <p>
          NEITHER Rovi91 Innovations Pvt Ltd NOR ITS AFFILIATES, EMPLOYEES,
          AGENTS OR CONSULTANTS SHALL IN ANY EVENT BE LIABLE FOR ANY
          INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES SUCH AS, BUT NOT
          LIMITED TO, LOSS OF BUSINESS INFORMATION, LOSS OF GOODWILL,
          BUSINESS INTERRUPTION OR LOSS OF ANTICIPATED PROFITS OR
          BENEFITS RESULTING FROM USE OF THE SITE OR ANY PART OR WHOLE
          OF THE CONTENT OR ARISING OUT OF ANY BREACH OF WARRANTY EVEN
          IF Rovi91 Innovations Pvt Ltd OR ITS AFFILIATES, EMPLOYEES, AGENTS OR CONSULTANTS
          HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SUCH
          LIMITATION OF LIABILITY SHALL APPLY WHETHER THE DAMAGES ARISE
          FROM USE OR MISUSE OF OR RELIANCE ON Rovi91 Innovations Pvt Ltd INFORMATION, FROM
          INABILITY TO USE Rovi91 Innovations Pvt Ltd INFORMATION, OR FROM THE
          INTERRUPTION, SUSPENSION, OR TERMINATION OF ACCESS TO THE
          CONTENT OR SITE (INCLUDING SUCH DAMAGES INCURRED BY THIRD
          PARTIES). THIS LIMITATION SHALL ALSO APPLY, WITHOUT
          LIMITATION, TO THE COSTS OF PROCUREMENT OF SUBSTITUTE CONTENT,
          LOSS OF GOODWILL, LOSS OF PROFITS, OR LOSS OF DATA. SUCH
          LIMITATION SHALL FURTHER APPLY WITH RESPECT TO THE PERFORMANCE
          OR NON-PERFORMANCE OF Rovi91 Innovations Pvt Ltd OR ANY INFORMATION THAT APPEARS
          ON, OR IS LINKED OR RELATED IN ANY WAY TO, THE SITE PROVIDED
          THEREUNDER. SUCH LIMITATION SHALL APPLY NOTWITHSTANDING ANY
          FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY AND TO THE
          FULLEST EXTENT PERMITTED BY LAW.
        </p>
        <h4>16. INDEMNITY</h4>

        <p>
          You agree to indemnify and hold Rovi91 Innovations Pvt Ltd and its
          subsidiaries, affiliates, officers, agents, and employees,
          harmless from any claim or demand, including reasonable
          attorneys' fees, made by any third party due to or arising out
          of the Contents you submit, e-mail, transmit or make available
          through the Site, your use of the Site, your connection to the
          Site, your violation of this Agreement, or your violation of
          any rights of another user of this Site.
        </p>
        <h4>17. ACKNOWLEDGMENT</h4>

        <p>
          The disclaimer and limited liability of Rovi91 Innovations Pvt Ltd
          as set out in this Agreement are fundamental elements of the
          basis of the bargain for the Content and access to the Site.
          You agree that Rovi91 Innovations Pvt Ltd would not otherwise be able to offer
          the Content or the Site on its present basis without such
          limitations. This clause shall survive any termination of this
          Agreement.
        </p>
        <h4>18. SPECIAL ADMONITIONS FOR INTERNATIONAL USE</h4>

        <p>
          Recognizing the global nature of the Internet,
          you agree to comply with all local rules regarding online
          conduct. Specifically, you agree to comply with all applicable
          laws regarding the transmission of technical data exported
          from the country in which you reside.
        </p>
        <h4>19. SEVERABILITY</h4>

        <p>
          Any provision of this Agreement which is
          invalid, prohibited or unenforceable in any jurisdiction
          shall:
        </p>

        <p>
          (i) be ineffective in that jurisdiction to the
          extent of the invalidity, prohibition or unenforceability;
        </p>

        <p>
          (ii) not invalidate the remaining provisions of
          this Agreement; and
        </p>

        <p>
          (iii) not affect the validity of that provision
          in any other jurisdiction.
        </p>

        <h4>20. GOVERNING LAW AND ARBITRATION</h4>

        <p>
          All legal proceedings shall be subject to the
          jurisdiction of the courts in Delhi, India and shall be
          governed by and construed in accordance with the laws of India
          and you agree to resolve the disputes under the Arbitration
          and Conciliation Act 1996. The venue for such arbitration
          shall be at Delhi, India.
        </p>
        <h4>21. RELATIONSHIP</h4>

        <p>
          This Agreement or your use of this Site does
          not constitute any joint venture, partnership, employment or
          agency relationship between you and Rovi91 Innovations Pvt Ltd.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TermsConditions",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA"
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
